import React from 'react'

/**
 * Ambient default for `EntityPreviewCard`'s `showTypeStripe` prop.
 *
 * The card renders its color-coded left type-stripe by default. Some result-
 * list containers (entity-search results, `ui:entitySelect` options) render
 * many cards at once, so the stripe would repeat down the column and add
 * visual noise; those containers wrap children in this provider with
 * `showTypeStripe: false` to opt out. Callers that pass `showTypeStripe`
 * explicitly to `EntityPreviewCard` always win over the context.
 */
export const EntityPreviewCardContext = React.createContext<{ showTypeStripe: boolean }>({
  showTypeStripe: true,
})
